export const BG_PSWD = "S<9G3rc!r&Pv";
